// extracted by mini-css-extract-plugin
module.exports = {"youtubeVideo":"YoutubeVideo_youtubeVideo__1bt_s"};